export abstract class AppError {
  message: string;
  errorId: any;
  status: number;
  statusText: string;
  oktaErrorMessage: any;
  data: any;
  messageId: string;
}